import api from '../api'
import {showWhitelistErrorModal} from './modals'


export function imageSearch(searchTerm,count,offset) {
  	return (dispatch) => api.fetchImageSearchResults(searchTerm,count,offset)
	    .then((response) => {
	    	return response
	    })
	    .catch((error) => {
	    	console.log(error)
	    	console.log(error.response.status)
	    	if(error.response && error.response.status ===403){
	    		console.log('cant do image search')
	    	}else{
			dispatch(showWhitelistErrorModal('imageSearch'))
			}
			throw error
			// return null
		})
}


export function gifSearch(searchTerm,limit,offset) {
  	return (dispatch) => api.fetchGifSearchResults(searchTerm,limit,offset)
	    .then((response) => {
	    	return response
	    })
	    .catch((error) => {
	    	//dispatch(showWhitelistErrorModal('gifSearch'))
			throw error
		})
}


// WEBPACK FOOTER //
// ./src/actions/imageSearch.js